import React, { Component } from 'react';
import {SERVER_URL}  from '../../Constants';
import axios from 'axios';
import auth0Client from '../../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import { Multiselect } from 'multiselect-react-dropdown';
import DatePicker from "react-datepicker";
import Toggle from "react-toggle-component"
const moment = require('moment');



export default class CategoryFilters extends Component {
  constructor(props) {
    super(props);
    this.state = 
      { 
        title:'',
        selectedCategories:[],
        categoriesMap:[],
        startDate: '',
        endDate: '',
        monthCd:'',
        startAge:'',
        endAge:'',
        checkInLocations:[],
        selectedCheckInLocations:[],
        selectedStatusItems:[],
        selectedStatus:'Q',
        keywords:'',
        savedDispositions:this.props.savedDispositions,
        selectedDisposition:{name:'', description:'', status:'Q'},
        selectedDispositionId:'',
        description:'',
        isRefreshing:false,
        finderClaimed:false,
      };

    // calculate stats when new rows loaded, i.e. onModelUpdated
    this.props.api.addEventListener(
      'rowSelected',
      this.updateTotals.bind(this)
    );
    this.multiselectCategoriesRef = React.createRef();
    this.multiselectcheckInsRef = React.createRef();
  }

  componentDidMount=()=>{
 
    this.loadReportCategories();
    this.loadCheckInLocationsForStorage();
    //this.loadSavedDispositions();
   
    }

  componentDidUpdate=()=>{

  }
 updateTotals() {


   
   ///this.setState({
   //     title: selectedRows[0].make
   // })

  
    /* this.props.api.forEachNode((rowNode) => {
      const data = rowNode.data;

    });

    */
}

setDateMacro=(event)=>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    //const name = target.name;

    let startDate = moment().clone().startOf('month').toDate();
    let endDate = moment().clone().endOf('month').toDate();

    if (value==='0'){
        // Last Three Months 
        startDate = moment().clone().startOf('month').subtract(2, 'months').toDate();
        endDate = moment().clone().endOf('month').toDate();

    }else if(value==='1'){
        // last year
        startDate = moment().clone().subtract(1, 'year').startOf('year').toDate()
        endDate = moment().clone().subtract(1, 'year').endOf('year').toDate()
    }else if (value==='2'){
        // this month
        startDate = moment().clone().startOf('month').toDate();
        endDate = moment().clone().endOf('month').toDate();
    }else if (value==='3'){
        // this year
        startDate = moment().clone().startOf('year').toDate();
        endDate = moment().clone().endOf('year').toDate();

    }else{
      startDate=undefined;
      endDate=undefined;
    }
    this.setState({
        startDate: startDate,
        endDate: endDate,
        monthCd: value,
       
    })
}
  loadReportCategories = ()=>{
    try {
      axios.get(`${SERVER_URL}/Reports/reportCategories`,{
         headers: { 
           'Authorization': `Bearer ${auth0Client.getIdToken()}`,
           'venueId' : auth0Client.getActiveVenuedId()
         }
        
        }).then((res)=>{
         
         if (res.status===undefined || res.status !==200) {
           //place your reentry code
           console.log("Error" + res.status);
           ToastStore.error("An error occured. Please try again");
          }
 
         const categoriesMap = res.data.categoriesMap;
         this.setState({
              categoriesMap : categoriesMap,
          
          });


        },
        (error)=>{
          if (error.response && error.response.status === 401){
            ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
          }else {
            ToastStore.error('An error occured:' + error.message);
          }
          
        }
        );
    }catch(e){
        //console.log(e);
        ToastStore.error('An error occured:' + e.message);
    }


 }

    // Loads the check in locations for the storage selection list.  Warehouse accounts
  // can only select from a specific list.
  loadCheckInLocationsForStorage=async()=>{

    try{
        const checkInLocations = (await axios.post(`${SERVER_URL}/CheckInOut/CheckInLocations`,{}, {
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
       
        let chekinLocationMap = [];
        for (var i=0; i<checkInLocations.length; i++){
          chekinLocationMap.push({id:checkInLocations[i]._id, name:checkInLocations[i].name})
        }
        this.setState({checkInLocations:chekinLocationMap})
    }catch(e){
      this.setState({checkInLocations:[]})
    }
      
  }

  loadSavedDispositions=async()=>{
    try{
      const resultsDTO = (await axios.get(`${SERVER_URL}/Dispo/items`,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
      let savedDispositions = [];
      if (resultsDTO && resultsDTO.items){
         savedDispositions=resultsDTO.items
      }
    
      this.setState({savedDispositions:savedDispositions})

      }catch(e){
        this.setState({savedDispositions:[]})
      }
  }

 handleInputChange=(event) =>{
  const target = event.target;
  const value = target.type === 'checkbox' ? target.checked : target.value;
  const name = target.name;

  this.setState({
    [name]: value
  });
}
 applyFilter=()=>{
     if (this.props.updateDisposition){
        let disposition = this.state.selectedDisposition;
   
        disposition.startDate = this.state.startDate;
        disposition.endDate=this.state.endDate;
        disposition.startAge=this.state.startAge;
        disposition.endAge=this.state.endAge;
        disposition.categories=this.state.selectedCategories;
        disposition.keywords=this.state.keywords;
        disposition.checkInLocations=this.state.selectedCheckInLocations;
        disposition.status=this.state.selectedStatus;
        disposition.finderClaimed=this.state.finderClaimed;
         this.props.updateDisposition(disposition);
     }
 }

 clearFilters=()=>{
  if (this.multiselectCategoriesRef) { this.multiselectCategoriesRef.current.resetSelectedValues();}
  if (this.multiselectcheckInsRef) { this.multiselectcheckInsRef.current.resetSelectedValues();}
  
  this.setState( 
            { 
            
              selectedCategories:[],
              startDate: '',
              endDate: '',
              monthCd:'',
              startAge:'',
              endAge:'',
              keywords:'',
              selectedCheckInLocations:[],
              selectedStatus:'Q',
              finderClaimed:false
            },()=>{
              this.applyFilter();
            });

 }

 save=()=>{
    if (this.props.save){
      this.props.save();
    }
 }

delete=()=>{
  if (this.props.delete){
    this.props.delete();
  }
}

 handleDispoChanged=(event)=>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (this.multiselectCategoriesRef) { this.multiselectCategoriesRef.current.resetSelectedValues();}
    if (this.multiselectcheckInsRef) { this.multiselectcheckInsRef.current.resetSelectedValues();}

    this.setState({
      [name]: value
    });
    // Locate the item in the list of dispositions
    let disposition = this.state.savedDispositions.find(i=>i._id===value);
    if(disposition && this.props.updateDisposition){
      console.log(disposition);
      this.setState( 
        { 
        
          selectedCategories:disposition.categories,
          startDate: (disposition.startDate) ? new Date(disposition.startDate) : '',
          endDate: (disposition.endDate) ? new Date(disposition.endDate) : '',
          monthCd:disposition.monthCd,
          startAge:disposition.startAge,
          endAge:disposition.endAge,
          keywords:disposition.keywords,
          selectedCheckInLocations:disposition.checkInLocations,
          selectedStatus:disposition.status,
          selectedDisposition:disposition,
          description:disposition.description,
          finderClaimed:disposition.finderClaimed
        },()=>{
         // console.log(this.state.selectedCheckInLocations);
          this.props.updateDisposition(disposition);
        });
     
    }else{
      this.clearFilters();
      this.setState({
        selectedDisposition:{name:'', description:'', status:'Q'},
        selectedDispositionId:''
      })
    }
   
    
    
 }

  render() {
  

    return (
      <div  className='container' style={{backgroundColor:'white'}}>
        <br/>
        <div className='col text-primary text-center'><h5>Filters</h5></div>
             <hr/>
            <div className="row">   
                      <div className="col-12">
                          <h6>Saved:</h6>
                          <select
                                  disabled={this.state.disabled}
                                  type="text"
                                  onChange={this.handleDispoChanged}
                                  name="selectedDispositionId"
                                  className="custom-select"
                                  placeholder=""
                                  value= {this.state.selectedDispositionId}
                                > 
                                <option key="*1" value=""></option>
                                {this.state.savedDispositions.map(item =>(
                                  <option key={item._id} value={item._id}>
                                  {item.name}
                              </option>
                                ))}
                                              
                                                                    
                                </select>   
                            </div>

                 </div>  
                 <br/>
                 <small >Description: {this.state.description}</small>
                 <br/>  <hr/>
            <div className='row'>      
                <div className='col'>
                  <h6>Keyword(s):</h6> 
                 
                </div>
               
            </div>
            <div className='row'>      
              
              <div className='col-11'>
                  <input
                            style={{Flex:1, backgroundColor:'white'}}
                            disabled={this.state.disabled}
                            type="text"
                            onChange={this.handleInputChange}
                            name="keywords"
                            className="form-control"
                            placeholder="Use a ',' inbetween each keyword"
                            value= {this.state.keywords}
                          />   
                          
              </div>

              </div>
            <hr/>

            <div className='row'>      
                <div className='col'>
                  <h6>Age:</h6> 
                </div>
            </div>
            <div className='row'>      
              
                <div className='col-4'>
                    <input
                              style={{width:75, backgroundColor:'white'}}
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="startAge"
                              className="form-control"
                              placeholder=""
                              value= {this.state.startAge}
                            />   
                            
                </div>
            
                <div className='col-2'>
                    <label style={{backgroundColor:'white'}} htmlFor="foundBy" className='text-primary'> To:</label>
                </div>
                <div className='col-5'>
                    <input
                              style={{width:75, backgroundColor:'white'}}
                              disabled={this.state.disabled}
                              type="text"
                              onChange={this.handleInputChange}
                              name="endAge"
                              className="form-control"
                              placeholder=""
                              value= {this.state.endAge}
                            />  
                            
                </div>
            </div>
            <br/><hr/>
            <div className='row'>      
                <div className='col'>
                  <h6>Release Date Range:</h6> 
                </div>
            </div>
            <br/>
            <div className='row'>      
                <div className='col'>
                    <select className='custom-select' style={{backgroundColor:'white'}}  value={this.state.monthCd} name='monthCd' onChange={this.setDateMacro}>
                         <option value=''>All</option>
                        <option value='0'>Last 3-Months</option>
                        <option value='1'>Last Year</option>
                        <option value='2'>This Month</option>
                        <option value='3'>This Year</option>

                    

                    </select>
                </div>
            </div>
            <br/>
           <div className='row'>      
                <div className='col'>
                    <label style={{width:100, backgroundColor:'white'}} htmlFor="exampleInputEmail1" className='text-primary'>From:</label>
                           
                             <DatePicker
                              className="form-control"
                              style={{ backgroundColor:'white'}}
                                onChange={date => this.setState({ startDate:date })}
                                name="foundDate"
                                selected={this.state.startDate}
                              /> 
                </div>
            </div>
            <br/>
            <div className='row'>  
                <div className='col'>
                    <label style={{width:100, backgroundColor:'white'}} htmlFor="foundBy" className='text-primary'> To:</label>
                    <DatePicker
                                    className="form-control"
                                    style={{ backgroundColor:'white'}}
                                    onChange={date => this.setState({ endDate:date })}
                                        name="foundDate"
                                        selected={this.state.endDate}
                                    /> 
                            
                </div>
            </div>
            <br/> <hr/>
            <div className='row'>
                <div className='col text-info text-center'><h6>Category Filters:</h6></div> 
                
            </div>
          
            <div className='row'>      
                <div className='col text-center'  style={{backgroundColor:'white'}}>

                              
              <Multiselect
                    ref={this.multiselectCategoriesRef}
                    showArrow={true}
                    displayValue='name'
                    options={this.state.categoriesMap} // Options to display in the dropdown
                    selectedValues={this.state.selectedCategories} // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) =>{
                      //console.log(selectedList);
                      this.setState({selectedCategories:selectedList})
                    }} // Function will trigger on select event
                    onRemove={(selectedList, removedItem)=>{
                     // console.log(selectedList);
                      this.setState({selectedCategories:selectedList})
                    }} // Function will trigger on remove event
                    style={{
                      chips: {
                      
                        fontSize: '1.2sem',
                        color:'white',
                        fontWeight:'bold'
                      },
                      multiselectContainer: {
                        color: 'black',
                        fontWeight:'bold'
                      },
                     
                    }}
              /></div>
                
                
                
              </div>
              <br/> <hr/>
              <div className='row'>
                <div className='col text-info text-center'><h6>Storage Filter:</h6></div> 
              </div>
              <div className='row'>      
                <div className='col text-center'  style={{backgroundColor:'white'}}>

                              
              <Multiselect
                    ref={this.multiselectcheckInsRef}
                    showArrow={true}
                    displayValue='name'
                    options={this.state.checkInLocations} // Options to display in the dropdown
                    selectedValues={this.state.selectedCheckInLocations} // Preselected value to persist in dropdown
                    onSelect={(selectedList, selectedItem) =>{
                      //console.log(selectedList);
                      this.setState({selectedCheckInLocations:selectedList})
                    }} // Function will trigger on select event
                    onRemove={(selectedList, removedItem)=>{
                     // console.log(selectedList);
                      this.setState({selectedCheckInLocations:selectedList})
                    }} // Function will trigger on remove event
                    style={{
                      chips: {
                      
                        fontSize: '1.2sem',
                        color:'white',
                        fontWeight:'bold'
                      },
                      multiselectContainer: {
                        color: 'black',
                        fontWeight:'bold'
                      },
                     
                    }}
              /></div>
                
                
                
              </div>

              <br/> <hr/>
              <div className='row'>
                <div className='col text-info text-center'><h6>Status Filter:</h6></div> 
              </div>

              <div className='row'>      
                <div className='col'>
                    <select className='custom-select' style={{backgroundColor:'white'}}  value={this.state.selectedStatus} name='selectedStatus' onChange={this.handleInputChange}>
                        <option value='AI'>In-Inventory</option>
                        <option value='A'>Archived</option>
                        <option value='C'>Claimed</option>
                        <option value='T'>Disposed</option>
                        <option value='D'>Donated</option>
                        <option value='R'>Returned</option>
                        <option value='Q'>Unclaimed</option>

                    </select>
                </div>
            </div>
            <br/> 
            <div className='row'>
                <div className='col text-info text-center'><h6>Finder Filters:</h6></div> 
              </div>

            <div className='row'>      
                <div className='col'>
                <Toggle id='finderClaimed' labelRight="Only include will claim" checked={this.state.finderClaimed} onToggle={value => this.setState({finderClaimed:value})} /> 
                  </div>
            </div>

            <br/><br/>
              <div className='row'>      
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn btn-success " id="optArchive" onClick={this.applyFilter} >Apply</button>
                </div>
            </div>
            <br/>
          

            <div className='row'> 
                 <div className='col-4 text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn  btn-link" disabled={auth0Client.lfReadOnly===true} id="optArchive" onClick={this.save} >{(this.state.selectedDisposition && this.state.selectedDisposition._id) ? 'Update...' : 'Save...'}</button>
                </div> 
                <div className='col-4 text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn  btn-link" disabled={(!(this.state.selectedDisposition && this.state.selectedDisposition._id)) || auth0Client.lfReadOnly===true}  id="optArchive" onClick={this.delete} >Delete</button>
                </div>   
                <div className='col-4 text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn btn-link" id="optArchive" onClick={this.clearFilters} >Clear</button>
                </div>
            </div>
                  <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
      </div>
    );
  }



 
}